/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportRecomputeReferralCreditsRequest
 */
export interface SupportRecomputeReferralCreditsRequest {
    /**
     * 
     * @type {string}
     * @memberof SupportRecomputeReferralCreditsRequest
     */
    userId: string;
}

/**
 * Check if a given object implements the SupportRecomputeReferralCreditsRequest interface.
 */
export function instanceOfSupportRecomputeReferralCreditsRequest(value: object): value is SupportRecomputeReferralCreditsRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function SupportRecomputeReferralCreditsRequestFromJSON(json: any): SupportRecomputeReferralCreditsRequest {
    return SupportRecomputeReferralCreditsRequestFromJSONTyped(json, false);
}

export function SupportRecomputeReferralCreditsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportRecomputeReferralCreditsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
    };
}

export function SupportRecomputeReferralCreditsRequestToJSON(json: any): SupportRecomputeReferralCreditsRequest {
    return SupportRecomputeReferralCreditsRequestToJSONTyped(json, false);
}

export function SupportRecomputeReferralCreditsRequestToJSONTyped(value?: SupportRecomputeReferralCreditsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
    };
}

